import Vue from 'vue';
import VueForm from 'vue-form';
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';
import VCalendar from 'v-calendar';
import App from './App.vue';
import router from './router';
import store from './store';
import { format } from 'date-fns';
import axios from 'axios';
import VueAxios from 'vue-axios';
import './assets/scss/main.scss';
import 'v-calendar/src/styles/base.css';
import { VTooltip } from 'v-tooltip'

Vue.config.productionTip = false;

// custom validators for Vue-form
const options = {
  validators: {
    'email-custom-validator': function (value) {
      // return true to set input as $valid, false to set as $invalid
      // eslint-disable-next-line no-useless-escape
      return !!(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value));
    }
  }
};

Vue.use(VueAxios, axios);
Vue.use(VueForm, options);
Vue.use(VCalendar, {
  locale: 'da-DK',
  firstDayOfWeek: 1,
  masks: {
    input: 'DD-MM-YYYY'
  },
  datePicker: {
    popover: {
      visibility: 'click',
      keepVisibleOnInput: false
    },
    inputDebounce: 300
  }
});

Vue.use(VueAnalytics, {
  id: 'UA-109524194-2'
});

Vue.use(VueGtm, {
  id: 'GTM-NV2DNCH', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.filter('dateFormat', function(date) {
  return format(date, 'DD[.]MM[.]YYYY')
});

Vue.directive('tooltip', VTooltip);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
